<template>
  <form-card
    labelText="Email Attachment"
  >
    <el-table
      :data="attach"
    >
      <el-table-column
        align="center"
        prop="type"
        :label="getLabelText('', 'attachType')"
        width="140"
      >
        <template slot-scope="scope">
          {{ getOptName('attachType', scope.row.attach_type) }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="file_name"
        :label="getLabelText(attachBase, 'file_name')"
      >
      </el-table-column>
      <el-table-column
        align="center"
        :label="getLabelText(attachBase, 'file_path')"
        fixed="right"
        width="120"
      >
        <template slot-scope="scope">
          <act-btn
            icon="el-icon-download"
            @click="downloadAttach(scope.row.file_path)"
            :tip="scope.row.file_path"
          >
          </act-btn>
        </template>
      </el-table-column>
    </el-table>
  </form-card>
</template>

<script>
import { getLabelText, getOptName } from '@/utils/i18n'
import { getFileURL } from '@/utils/path'

export default {
  name: 'attach-table',
  data () {
    return {
    }
  },
  props: {
    base: {
      type: String,
      required: true
    },
    attach: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    attachBase () {
      return this.base + '.attach'
    }
  },
  methods: {
    getLabelText,
    getFileURL,
    getOptName,
    downloadAttach (path) {
      let url = path.replace(/^\/cdn/, '')
      window.open(this.getFileURL(url), '_blank')
    }
  }
}
</script>
